import {
  BookOpenIcon,
  ChatBubbleBottomCenterIcon,
  DocumentArrowDownIcon,
  DocumentArrowUpIcon,
  DocumentTextIcon,
  EnvelopeIcon,
  FunnelIcon,
  ListBulletIcon,
  PencilIcon,
  PhoneIcon,
  PlayIcon,
  TrashIcon,
  UserPlusIcon,
} from "@heroicons/react/24/outline";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button";
import FilteredTable from "../../components/FilteredTable";
import { LoadingMask } from "../../components/LoadingMask";
import {
  ConversationsPath,
  LeadsPoolPath,
  NewLeadPath,
  UpdateLeadPath,
} from "../../constants/Routes";
import { LeadStatusEnum, LeadStatusLabel } from "../../enums/LeadStatus";
import { Modal } from "../../components/Modal";
import { ReactiveFormUploadFile } from "../../components/form/ReactiveFormUploadFile";
import { useForm } from "react-hook-form";
import * as xlsx from "xlsx";
import { Lead, NewUploadLead } from "../../models/Lead";
import { AppDispatch, RootState } from "../../state/store";
import { ToastContainer, toast } from "react-toastify";
import { deleteLead, fetchLeads, pastPage, setLeadsActiveTab, startLeadAutomation, uploadAgencyLeads, uploadAgentLeads } from "../../state/leads/actions";
import { ReactiveFormSelect } from "../../components/form/ReactiveFormSelect";
import { Toast } from "../../components/Toast";
import {
  createConversation,
  fetchConversationMessages,
  fetchConversations,
} from "../../state/twilio/actions";
import { ConversationType } from "../../enums/ConversationType";
import uploadLeadTemplate from "../../assets/templates/uploadLeadTemplate.xlsx";
import { RoleEnum } from "../../enums/Role";
import { dateFormat, shortDateFormat } from "../../utils/functions";
import { LeadFilterModal } from "./LeadFilterModal";
import { motion } from "framer-motion";
import { User } from "../../models/User";
import { AgentBackUpLead, AgentBackUpLeadabel } from "../../enums/AgentBackUp";
import { BackUpOptions } from "../../enums/BackupOptions";
import { ConfirmationModal } from "../../components/ConfirmationModal";
import { Client } from "../../models/Client";
import { FrequencyFormModel } from "../../models/FollowUp";
import { AssignFrequencyAutomationModal } from "../Automations/AssignFrequencyAutomationModal";
import { assingFollowUpMessage } from "../../state/automations/action";
import { MessageTypeEnum } from "../../enums/MessageType";
import { SuccessErrorModal } from "../../components/SuccessErrorModal";
import { SentLeadMailConfirmationModal } from "../../components/leads/mail/SentLeadMailConfirmation";
import { checkMailLeadAddress, createMailLead } from "../../state/mail/actions";
import { LeadAddress } from "../../models/Address";
import { MailType } from "../../models/Mail";
import { SentMailSelectTypeModal } from "../../components/clients/mail/SentMailSelectTypeModal";
import { DeleteLeadModal } from "../../components/leads/DeleteLeadModal";
import { Device } from "@twilio/voice-sdk";

interface Props {
  makePhoneCall: (phone: string) => void;
}

const tabs = [AgentBackUpLead.MY_LEADS, AgentBackUpLead.BACKUP_LEADS];

export const Leads = (props: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const pageLeads = useSelector((state: RootState) => state.leads.pageLeads);
  const isLoading = useSelector((state: any) => state.leads.isLoading);
  const error = useSelector((state: any) => state.leads.error);
  const paginatedOptions = useSelector((state: RootState) => state.leads.paginatedOptions);
  const filters = useSelector((state: any) => state.leads.filters);
  const [isOpenUploadModal, setIsOpenUploadModal] = useState(false);
  const [isUploadingLeads, setIsUploadingLeads] = useState(false);
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const currentUser = useSelector((state: any) => state.users.currentUser);
  const [isOpenStartAutomationModal, setIsOpenStartAutomationModal] =
    useState(false);
  const [isStartingAutomation, setIsStartingAutomation] = useState(false);
  const [isFilterModalOpen, setFilterModalOpen] = useState<boolean>(false);
  const [selectedLead, setSelectedLead] = useState<Lead | null>(null);
  const automations = useSelector(
    (state: any) => state.automations.automations
  );
  const twilioChatState = useSelector(
    (state: any) => state.twilio.areTwilioCredentialsValid
  );
  const deviceState:Device.State = useSelector(
    (state: any) => state.twilio.twilioDeviceState
  );
  const twilio = useSelector((state: any) => state.twilio);
  const [showError, setShowError] = useState(false);
  const leadsActiveTab = useSelector((state: RootState) => state.leads.leadActiveTab);
  const [activeTab, setActiveTab] = useState(leadsActiveTab ?? AgentBackUpLead.MY_LEADS);
  const backupOfAgents = useSelector((state: RootState) => state.users.backupOfAgents);
  const [canEditLead, setCanEditLead] = useState<boolean>()

  const [infoFilterModal, setInfoFilterModal] = useState<{
    myLeads: boolean;
    backupOfAgents: User[];
  }>({ myLeads: leadsActiveTab === AgentBackUpLead.MY_LEADS, backupOfAgents: leadsActiveTab === AgentBackUpLead.MY_LEADS ? [] : backupOfAgents });

  const [isConfirmationLoading, setIsConfirmationLoading] = useState(false);

  const [assignFrequencyAutomationModal, setAssignFrequencyAutomationModal] = useState<{
    show: boolean;
    lead?: Lead;
  }>({ show: false, lead: undefined });

  const isSendMailLoading = useSelector((state: RootState) => state.mails.isLoading);
  const mailError = useSelector((state: any) => state.mails.error);
  const agencyMailTypes = useSelector((state: RootState) => state.mails.agencyMailTypes)
  const [showMailError, setShowMailError] = useState(false);
  const [seletedAddress, setSelectedAddress] = useState<LeadAddress | null>(null);
  const [errorMailMessage, setErrorMailMessage] = useState<string | null>(null);

  const [ showSentLeadMailConfirmationModal, setShowSentLeadMailConfirmationModal] = useState<{
    lead?: Lead;
    show: boolean;
  }>({ show: false, lead: undefined });

  const [ showDeleteLeadModal, setShowDeleteLeadModal] = useState<{
    lead?: Lead;
    show: boolean;
  }>({ show: false, lead: undefined });

  const [showSuccessErrorModal, setShowSuccessErrorModal] = useState<{
    show: boolean;
    messageType: number;
    message: string;
    failedButtonMessage?: string;
  }>({ show: false, messageType: 2, message: "" });

  const [sentMailSelectTypeModal, setSentMailSelectTypeModal] = useState<{
    show: boolean;
    agencyMailTypes?: any;
  }>({ show: false, agencyMailTypes: [] });

  useEffect(() => {
    if (showError) {
      Toast(t(error?.reason ?? "SOMETHING_WENT_WRONG"), t(error?.cause_info));
      setShowError(false);
    }
  }, [showError, error, t]);

  useEffect(() => {
    if (showMailError) {
      if(mailError?.cause_info) {
        if(mailError?.cause_info === "LEAD_ALREADY_IN_MAIL_LIST") {
          handleShowSuccessErrorModal(
            MessageTypeEnum.FAILED,
            t(mailError?.cause_info),
            t("ACCEPT")
          );
        } else {
          handleShowSuccessErrorModal(
            MessageTypeEnum.FAILED,
            t(mailError?.cause_info),
            t("UPDATE_LEAD_ADDRESS")
          );
        }
        setErrorMailMessage(mailError?.cause_info)
      } else {
        handleShowSuccessErrorModal(
          MessageTypeEnum.FAILED,
          t("SOMETHING_WENT_WRONG"),
          t("UPDATE_LEAD_ADDRESS")
        );
        setErrorMailMessage(null)
      }
    }
  }, [showMailError, mailError, t]);

  useEffect(() => {
    if(currentUser?.role_id === RoleEnum.AGENT) {
      if(leadsActiveTab === AgentBackUpLead.BACKUP_LEADS) {
        if(currentUser?.agency && currentUser?.agency.backup_config_id === BackUpOptions.ONLY_READ) {
          setCanEditLead(false);
        } else {
          setCanEditLead(true);
        }
      } else {
        setCanEditLead(true);
      }
    } else {
      setCanEditLead(true);
    }
  }, [currentUser]);

  const methods = useForm<{}>();
  const { control } = methods;

  const startMethods = useForm<{}>();
  const { handleSubmit: handleStartSubmit, control: startControl } =
    startMethods;

  const makeConversation = useCallback(
    (phone: string) => {
      if (twilio.conversations && currentUser) {
        const selectedConversation = twilio.conversations.find(
          (x: any) => x.friendlyName === phone
        );
        if (selectedConversation) {
          dispatch(
            fetchConversationMessages({
              conversationSid: selectedConversation.sid,
            })
          );
        } else {
          dispatch(
            createConversation({
              newConversation: {
                from: currentUser.main_twilio_number?.twilio_phone,
                to: phone,
              },
              conversationType: ConversationType.LEADS,
            })
          );
        }
        navigate(ConversationsPath);
      }
    },
    [twilio.conversations, currentUser, dispatch, navigate]
  );
  
  const handleRowClick = (lead: any) => {
    updateLead(lead);
  };

  const renderClickableCell = (value: any, row: any) => (
    <div
      onClick={() => handleRowClick(row.row.original)}
      className="w-full h-full block px-2 py-1 cursor-pointer hover:bg-gray-100"
    >
      {value}
    </div>
  );

  const columns = useMemo(() => {
    const showColumns = [
      {
        Header: t("NAME"),
        Cell: (row: any) => {
          const { first_name, last_name } = row.row.original;
          const fullName = `${first_name ?? ""} ${last_name ?? ""}`;
          return renderClickableCell(fullName, row);
        },
      },
      {
        Header: t("PHONE"),
        accessor: "phone",
        Cell: (row: any) => renderClickableCell(row.value, row),
      },
      {
        Header: t("EMAIL"),
        accessor: "email",
        Cell: (row: any) => renderClickableCell(row.value, row),
      },
      {
        Header: t("STATUS"),
        Cell: (row: any) => {
          const label = LeadStatusLabel(`${row.row.original.status_id}`);
          return renderClickableCell(label, row);
        },
      },
      {
        Header: t("AGENT"),
        Cell: (row: any) => {
          const { agent_name } = row.row.original;
          return renderClickableCell(`${agent_name ?? ""}`, row);
        },
      },
    ];


    const actions = {
      Header: " ",
      Cell: (row: any) => {
        return (
          <div className="flex flex-row justify-center divide-x">
            <Button
              isTerciary
              /*isDisabled={canRunAutomation(row.row.original)}*/
              iconOnly
              tooltip={t("ASSIGN_FREQUENCY_AUTOMATION")}
              onClick={() => openSelectFrequencyAutomationModal(row.row.original)}
              classNames="mr-2"
            >
              <PlayIcon className="h-5 aspect-square stroke-gold" />
            </Button>
            <Button
              isTerciary
              isDisabled={!twilioChatState}
              tooltip={t("START_CONVERSATION")}
              iconOnly
              onClick={() => makeConversation(row.row.original.phone)}
              classNames="pl-2"
            >
              <ChatBubbleBottomCenterIcon className="h-5 aspect-square stroke-gold" />
            </Button>
            <Button
              isTerciary
              isDisabled={deviceState !== Device.State.Registered}
              tooltip={t("CALL_LEAD")}
              iconOnly
              onClick={() => props.makePhoneCall(row.row.original.phone)}
              classNames="pl-2"
            >
              <PhoneIcon className="h-5 aspect-square stroke-gold" />
            </Button>
            <Button
              isTerciary
              tooltip={t("SEND_MAIL")}
              iconOnly
              onClick={() => setShowSentLeadMailConfirmationModal({ show: true, lead: row.row.original })}
              classNames="mr-2"
            >
              <EnvelopeIcon className="h-5 aspect-square text-blue" />
            </Button>
            <Button
              isTerciary
              iconOnly
              tooltip={t("UPDATE_LEAD")}
              onClick={() => updateLead(row.row.original)}
              classNames="mr-2"
            >
              <PencilIcon className="h-5 aspect-square stroke-blue" />
            </Button>
            <Button
              isTerciary
              tooltip={t("DELETE_LEAD")}
              iconOnly
              onClick={() => setShowDeleteLeadModal({ show:true, lead: row.row.original })}
              classNames="mr-2"
            >
              <TrashIcon className="h-5 aspect-square text-red-600" />
            </Button>
          </div>
        );
      },
    };

    const backupActions = {
      Header: " ",
      Cell: (row: any) => {
        return (
          <div className="flex flex-row justify-center divide-x">
            <Button
              isTerciary
              tooltip={t("LEAD_INFORMATION")}
              iconOnly
              onClick={() => updateLead(row.row.original)}
              classNames="mr-2"
            >
              <BookOpenIcon className="h-5 aspect-square text-blue" />
            </Button>
          </div>
        );
      },
    };

    if(!canEditLead) {
      return [...showColumns, backupActions]
    }

    return [...showColumns, actions];
  },[t, twilioChatState, deviceState, currentUser, canEditLead]
  );

  const canRunAutomation = (row: any) => {
    if (row.status_id === LeadStatusEnum.CLIENT) {
      return true;
    } else {
      const conversation = twilio.conversations.find(
        (conv: any) => conv.friendlyName === row.phone
      );
      if (conversation !== undefined) {
        if (conversation.attributes["isInAutomation"]) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  };

  const updateLead = (row: any) => {
    navigate(UpdateLeadPath, { state: { lead: row } });
  };

  const openUploadLeadsModal = () => {
    setIsOpenUploadModal(true);
  };

  const closeUploadLeadsModal = () => {
    setIsOpenUploadModal(false);
    setSelectedFile(null);
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = link.href = uploadLeadTemplate;
    link.download = "uploadLeadsTemplate.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const showUploadLeadsModal = () => {
    return (
      <Modal
        thirdButton={{
          label: t("UPLOAD_EXAMPLE"),
          onClick: () => handleDownload(),
          icon: <DocumentArrowDownIcon />,
        }}
        isOpen={isOpenUploadModal}
        onClose={closeUploadLeadsModal}
        label={t("UPLOAD_LEADS")}
        saveButton={{
          label: t("UPLOAD"),
          icon: <DocumentArrowUpIcon />,
          onClick: handleSubmitSendDocument,
        }}
      >
        {isUploadingLeads && <LoadingMask />}
        <div className="w-full flex flex-wrap">
          {!selectedFile && (
            <ReactiveFormUploadFile
              control={control}
              className="md:w-1/1"
              label={t("LEADS_FILE")}
              name="leads_file"
              handleOnChange={handlePlanQuotedFiles}
            />
          )}
          {selectedFile && (
            <div className="w-full px-4 mb-3">
              <div className="flex justify-between">
                <label className="text-base font-semibold self-center">
                  {selectedFile.name}
                </label>
                <Button
                  iconOnly
                  classNames="h-7 w-7 self-end"
                  onClick={handleRemoveUploadLeadFile}
                >
                  <TrashIcon className="h-3 w-3" />
                </Button>
              </div>
            </div>
          )}
        </div>
      </Modal>
    );
  };

  const handlePlanQuotedFiles = (e: any) => {
    setSelectedFile(e[0]);
  };

  const handleRemoveUploadLeadFile = () => {
    setSelectedFile(null);
  };

  const handleSubmitSendDocument = async () => {
    setIsUploadingLeads(true);
    const reader = new FileReader();
    reader.readAsBinaryString(selectedFile);
    reader.onload = (e: any) => {
      const data = e.target.result;
      const workbook = xlsx.read(data, {
        type: "binary",
        cellDates: true,
        cellNF: false,
        cellText: false,
      });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const parsedData = xlsx.utils.sheet_to_json(sheet);
      uploadFileLeads(parsedData);
    };
  };

  const uploadFileLeads = async (xlsxData: any[]) => {
    const leads = xlsxData.map((row) => {
      const d: NewUploadLead = {
        first_name: row["FirstName"],
        last_name: row["LastName"],
        dob: row["DOB"] != undefined ? dateFormat(row["DOB"]): undefined,
        phone: `+${row["Phone"]}`,
        email: row["Email"],
        address: row["Address"],
        state: row["State"],
        city: row["City"],
        zip_code: row["ZipCode"],
        source_id: row["Source"],
        referred_by: row["ReferredBy"],
        referred_amount: row["ReferredAmount"],
        automation_code: row["AutomationCode"],
        campaign_code: row["CampaignCode"]
      };
      return d;
    });

    if(currentUser.role_id === RoleEnum.AGENT) {
      dispatch(uploadAgentLeads(leads)).then((e) => {
        if (e.type === "leads/uploadAgentLeads/rejected") {
          setShowError(true);
          setIsUploadingLeads(false);
        } else {
          toast(t("SAVED_SUCCESFULLY"));
          closeUploadLeadsModal();
          setIsUploadingLeads(false);
          //navigate(LeadsPath)
        }
      });
    } else {
      dispatch(uploadAgencyLeads({agencyId: currentUser.agency.id, isFromPool: false, leads: leads})).then((e) => {
        if (e.type === "leads/uploadAgencyLeads/rejected") {
          setShowError(true);
          setIsUploadingLeads(false);
        } else {
          toast(t("SAVED_SUCCESFULLY"));
          closeUploadLeadsModal();
          setIsUploadingLeads(false);
          //navigate(LeadsPath)
        }
      });
    }
  };

  const openStartAutomationModal = (lead: Lead) => {
    setSelectedLead(lead);
    setIsOpenStartAutomationModal(true);
  };

  const closeStartAutomationModal = () => {
    setIsOpenStartAutomationModal(false);
    setSelectedFile(null);
  };

  const showRunAutomationModal = () => {
    return (
      <Modal
        isOpen={isOpenStartAutomationModal}
        onClose={closeStartAutomationModal}
        label={t("RUN_AUTOMATION")}
        onSave={handleStartSubmit(onStartAutomationSubmit)}
      >
        {isStartingAutomation && <LoadingMask />}
        <div className="w-full flex flex-wrap">
          <div className="w-full">
            <ReactiveFormSelect
              width="md:w-1/1"
              name={`automation_id`}
              label={t("AUTOMATION")}
              options={getAutomations}
              control={startControl}
            />
          </div>
        </div>
      </Modal>
    );
  };

  const onStartAutomationSubmit = (data: any) => {
    setIsStartingAutomation(true);

    dispatch(
      startLeadAutomation({
        phone: selectedLead!.phone,
        automationId: data.automation_id!,
      })
    ).then((e) => {
      if (e.type === "leads/startAutomation/rejected") {
        setShowError(true);
        setIsStartingAutomation(false);
      } else {
        toast(t("AUTOMATION_STARTED_SUCCESFULLY"));
        dispatch(
          fetchConversations()
        );
        closeStartAutomationModal();
        setIsStartingAutomation(false);
        setSelectedLead(null);
      }
    });
  };

  const getAutomations = useMemo(() => {
    return automations.map((a: any) => {
      return {
        label: `${a.name}`,
        value: `${a.id}`,
        key: a.id,
      };
    });
  }, [automations]);

  const getPaginationOptions = useMemo(() => {
    return {
        page: paginatedOptions.page,
        pageSize: paginatedOptions.pageSize,
        totalPages: paginatedOptions.totalPages,
        totalCount: paginatedOptions.totalCount,
        setPage: (value: number) => {
            value < paginatedOptions.page
            ? dispatch(pastPage())
            : dispatch(fetchLeads({page: value,pageSize: paginatedOptions.pageSize, filters: filters, changeLeads: false}));
        },
        setPageSize: (value: number) => dispatch(fetchLeads({page: paginatedOptions.page,pageSize: value, filters: filters, changeLeads: false})),
    };
  }, [dispatch, paginatedOptions]);

  const onHandleChangeTab = (tab: number) => {
    if(tab !== activeTab) {
      setActiveTab(tab);
      if(tab === AgentBackUpLead.MY_LEADS) {
        setInfoFilterModal({ myLeads: true, backupOfAgents: [] });
        dispatch(fetchLeads({ page: 0, pageSize: 10, filters: {agents: [currentUser?.id]}, changeLeads: true })).then((e) => {
          if (e.type === "leads/rejected") {
            setShowError(true);
          } else {
            setCanEditLead(true);
          }
        })
        dispatch(setLeadsActiveTab(tab));

      } else {
        setInfoFilterModal({ myLeads: false, backupOfAgents: backupOfAgents });
        const filterAgents = backupOfAgents.map((a) => {return a.id!});
        dispatch(fetchLeads({ page: 0, pageSize: 10, filters: {agents: filterAgents}, changeLeads: true })).then((e) => {
          if (e.type === "leads/rejected") {
            setShowError(true);
          } else {
            if(currentUser?.agency && currentUser?.agency.backup_config_id === BackUpOptions.ONLY_READ) {
              setCanEditLead(false);
            } else {
              setCanEditLead(true);
            }
          }
        })
        dispatch(setLeadsActiveTab(tab));

      }
    }
  }

  const onDeleteLead = (lead: Lead) => {
    setIsConfirmationLoading(true);

    dispatch(
      deleteLead({
        leadId: lead.id!,
        page: paginatedOptions.page,
        pageSize: paginatedOptions.pageSize,
      })
    ).then((e) => {
      if (e.type === "clients/deleteClient/rejected") {
        setIsConfirmationLoading(false);
        setShowError(true);
      } else {
        toast(t("SUCCESSFULLY_DELETE_LEAD"));
        setIsConfirmationLoading(false);
      }
    });
  };

  const openSelectFrequencyAutomationModal = (lead: Lead) => {
    setAssignFrequencyAutomationModal({ show: true, lead: lead });
  }

  const onCheckLeadAddressMail = (lead: Lead) => {
    dispatch(checkMailLeadAddress({leadId: lead.id!})).then((e) => {
      if (e.type === "mail/checkMailLeadAddress/rejected") {
        setShowMailError(true);
        setSelectedLead(lead);
      } else {
        let leadAddress = (e.payload || {}) as LeadAddress;
        setSelectedAddress(leadAddress);
        setSelectedLead(lead);
        setSentMailSelectTypeModal({ show: true, agencyMailTypes: getMailTypes })
      }
    });
  };

  const onSelectedMailType = (mailType: MailType) => {
    if(selectedLead && seletedAddress) {
      onSentClientMail(selectedLead, seletedAddress, mailType);
    }
  }

  const onSentClientMail = (lead: Lead, address: LeadAddress, mailType: MailType) => {
    let name = lead.first_name + " " + lead.last_name;

    const data = {
      lead_id: lead.id,
      full_name: name,
      phone: lead.phone,
      address_line_1: address.address,
      address_line_2: null,
      city: address.city,
      state: address.state,
      zip_code: address.zip_code,
      country: address.country,
      mail_type_id: mailType.id
    };

    dispatch(createMailLead({newMailLead: data})).then((e) => {
      if (e.type === "mail/createMailLead/rejected") {
        setShowMailError(true);
        setSelectedLead(lead);
      } else {
        handleShowSuccessErrorModal(
          MessageTypeEnum.SUCCESS,
          t("SUCCESSFULLY_SENT_LEAD_MAIL")
        );
      }
    });
  };
  
  const handleShowSuccessErrorModal = (messageType: number, message: string, failedButtonMessage?: string) => {
    setShowSuccessErrorModal({
      show: true,
      messageType: messageType,
      message: message,
      failedButtonMessage: failedButtonMessage
    });
  };
  
  const handleCloseSuccessErrorModal = () => {
    if (showSuccessErrorModal.messageType === MessageTypeEnum.SUCCESS) {
      setShowSuccessErrorModal({
        show: false,
        messageType: MessageTypeEnum.SUCCESS,
        message: "",
      });
      setSelectedAddress(null);
      setSelectedLead(null);
    } else if (showSuccessErrorModal.messageType === MessageTypeEnum.FAILED) {
      setShowSuccessErrorModal({
        show: false,
        messageType: MessageTypeEnum.FAILED,
        message: "",
      });
      setShowMailError(false);
      setSelectedAddress(null);
      setSelectedLead(null);

      if(errorMailMessage !== null) {
        if(errorMailMessage !== "LEAD_ALREADY_IN_MAIL_LIST") {
          updateLead(selectedLead)
        }
      }
    }
  };

  const getMailTypes = useMemo(() => {
    return agencyMailTypes.map((a: any) => {
      return {
        label: `${a.name}`,
        value: `${a.id}`,
        key: a.id,
      };
    });
  }, [agencyMailTypes]);

  return (
    <>
      {(isLoading || isSendMailLoading) && <LoadingMask />}
      {showUploadLeadsModal()}
      {showRunAutomationModal()}
      <ToastContainer progressStyle={{ background: "#D4AF37" }} />
      <FilteredTable
        columns={columns}
        data={pageLeads}
        isPaginated
        paginationOptions={getPaginationOptions}
        hasSearchBar={false}
        buttonAction={
          <Button
            onClick={() => setFilterModalOpen(true)}
            iconOnly
            classNames="w-9 p-1 aspect-square mr-4 "
          >
            <FunnelIcon className=""></FunnelIcon>
          </Button>
        }
        secondaryActionButton={
          <Button onClick={() => navigate(NewLeadPath)}>
            <span className="flex items-center font-semibold pr-3">
              <div className="w-8 p-1 aspect-square mr-2">
                <UserPlusIcon />
              </div>
              {t("NEW_LEAD")}
            </span>
          </Button>
        }
        tertiaryActionButton={
          <Button
            isTerciary={true}
            classNames="ml-3"
            onClick={openUploadLeadsModal}
          >
            <span className="flex items-center font-semibold pr-3">
              <div className="w-8 p-1 aspect-square mr-2">
                <DocumentArrowUpIcon />
              </div>
              {t("UPLOAD_LEADS")}
            </span>
          </Button>
        }
        quaternaryActionButton={
          currentUser && currentUser?.role_id === RoleEnum.AGENT && backupOfAgents.length > 0
          ? <div className="flex flex-row items-center">
              <div className="relative flex border border-gray-300 rounded-lg w-64 p-1 bg-neutral-200 mr-1">
                {tabs.map((tab) => (
                  <button
                    key={tab}
                    onClick={() => onHandleChangeTab(tab)}
                    className={`relative flex-1 text-center py-2 text-sm font-medium transition-colors ${activeTab === tab ? "text-black" : "text-gray-400"
                      }`}
                  >
                    {activeTab === tab && (
                      <motion.div
                        layoutId="tab-indicator"
                        className="absolute inset-0 bg-white rounded-md shadow"
                      />
                    )}
                    <span className="relative">{AgentBackUpLeadabel(`${tab}`)}</span>
                  </button>
                ))}
              </div>
              <Button
                classNames="ml-2"
                onClick={() => navigate(LeadsPoolPath)}
              >
                <span className="flex items-center font-semibold pr-3">
                  <div className="w-8 p-1 aspect-square mr-2">
                    <ListBulletIcon />
                  </div>
                  {t("LEADS_POOL")}
                </span>
              </Button>
            </div>
          : <Button
              classNames="ml-2"
              onClick={() => navigate(LeadsPoolPath)}
            >
              <span className="flex items-center font-semibold pr-3">
                <div className="w-8 p-1 aspect-square mr-2">
                  <ListBulletIcon />
                </div>
                {t("LEADS_POOL")}
              </span>
            </Button>
        }
      />
      <LeadFilterModal
        info={infoFilterModal}
        isFilterModalOpen={isFilterModalOpen}
        setFilterModalOpen={() => setFilterModalOpen(false)}
      />
      <AssignFrequencyAutomationModal 
        info={assignFrequencyAutomationModal}
        onClose={() => setAssignFrequencyAutomationModal({ show: false, lead: undefined })}
      />
      <SentLeadMailConfirmationModal
        info={showSentLeadMailConfirmationModal}
        onClose={() => setShowSentLeadMailConfirmationModal({show : false, lead: undefined})}
        sentMail={(lead: Lead) => onCheckLeadAddressMail(lead)}
      />
      <SentMailSelectTypeModal
        info={sentMailSelectTypeModal}
        onSubmited={(selectedType) => {
          const mType = agencyMailTypes.find((e: any) => e.id === +selectedType);
          if(mType) {
            onSelectedMailType(mType);
          }
        }}
        onClose={() => setSentMailSelectTypeModal({ show: false, agencyMailTypes: [] })}
      />
      <SuccessErrorModal
        info={showSuccessErrorModal}
        onClose={handleCloseSuccessErrorModal}
      />
      <DeleteLeadModal
        info={showDeleteLeadModal}
        onClose={() => setShowDeleteLeadModal({ show: false, lead: undefined })}
        deleteLead={(lead: Lead) => onDeleteLead(lead)}
      />
    </>
  );
};
